// Libraries
var React = require('react');
var dateFormat = require('dateformat');

// Styles
require('../Hero.scss');
require('./FixtureHero.scss');

// Components
var CallToAction = require('CallToAction/CallToAction');
var LocalTimeConverter = require('LocalTimeConverter/LocalTimeConverter');

// Assets
var placeholder = require('images/transparent1px.png');

// TODO:
// 1. make the hero's background image responsive with the difference sizes from json file

class FixtureHeroModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			kickOff: "",
			kickOffDay: ""
		};
	}

	componentDidMount = () => {
		// delay this until the component mounts on the client side
		// to avoid server side / client side local time mismatching

		if(!this.props.data.fixture || !this.props.data.fixture.kickOff)
			return;

		var kickOff = new Date(this.props.data.fixture.kickOff);

		kickOff = LocalTimeConverter(kickOff);

		if(this.props.data.fixture && kickOff) {
			this.setState({kickOffDay: dateFormat(kickOff, "dddd")});
			this.setState({kickOff: dateFormat(kickOff, "dd mmmm HH:MM")});
		}
	}

	render() {
		const images = this.props.data.fixture ? this.props.data.fixture.stadium.image : this.props.data.fallback.image;

		return (
			<div className="FixtureHero" ref={(hero) => { this.hero = hero; }} data-bg={images.smallUrl + '*,*' + images.mediumUrl + '*,*' + images.largeUrl + '*,*' + images.extraLargeUrl}>
				<div className="FixtureHero__outer-wrapper">
					<div className="FixtureHero__wrapper">
						<div className="FixtureHero__title">
							<h1>{this.props.data.fixture ? "NEXT MATCH" : this.props.data.fallback.title}</h1>
							<p className="tags">
								{this.props.data.fixture && this.props.data.fixture.tag &&
										<a href={this.props.data.fixture.tag.url} rel="nofollow">{this.props.data.fixture.tag.hashtag} </a>
								}                                
								{this.props.data.fallback && this.props.data.fallback.tag &&
										<a href={this.props.data.fallback.tag.url}>{this.props.data.fallback.tag.hashtag} </a>
								}
							</p>
						</div>
						{this.props.data.fixture &&
							<div>
								{this.props.data.fixture.showKickOffOverrideText &&
									<div class="FixtureHero__kickoff">
										<p>{this.props.data.fixture.kickOffOverrideText}</p>
									</div>
								}
								{!this.props.data.fixture.showKickOffOverrideText &&
									<div className="FixtureHero__kickoff">
										<span>{this.state.kickOffDay}</span>
										<p>{this.state.kickOff}</p>
									</div>
								}
								<div className="FixtureHero__crests">
									<div className="home">
										{this.props.data.fixture.homeTeam.lightCrest && 
												<img src={placeholder} data-src={this.props.data.fixture.homeTeam.lightCrest.smallUrl} alt={this.props.data.fixture.homeTeam.lightCrest.altText} />
										}
										<p>{this.props.data.fixture.homeTeam.shortName}</p>
									</div>
									<span>VS</span>
									<div className="away">
										{this.props.data.fixture.awayTeam.lightCrest && 
												<img src={placeholder} data-src={this.props.data.fixture.awayTeam.lightCrest.smallUrl} alt={this.props.data.fixture.awayTeam.lightCrest.altText} />
										}
										<p>{this.props.data.fixture.awayTeam.shortName}</p>
									</div>
								</div>
								<div className="FixtureHero__stadium">
									<p>{this.props.data.fixture.competition.name}</p>
									<span className="separator">|</span>
									<p className="location">{this.props.data.fixture.stadium.displayName}</p>
								</div>
							</div>                   
						}
						{this.props.data.fixture && this.props.data.fixture.fixtureLink &&
								<CallToAction {...this.props.data.fixture.fixtureLink} />
						}
						{this.props.data.fallback && this.props.data.fallback.link &&
								<CallToAction {...this.props.data.fallback.link} />
						}
					</div>
					{this.props.data.fixture &&
							<div className="FixtureHero__desktop">
								<div className="FixtureHero__crests">
									<div className="home">
										{this.props.data.fixture.homeTeam.lightCrest && 
												<img src={placeholder} data-src={this.props.data.fixture.homeTeam.lightCrest.smallUrl} alt={this.props.data.fixture.homeTeam.lightCrest.altText} />
										}
										<p>{this.props.data.fixture.homeTeam.name}</p>
									</div>
									<span>VS</span>
									<div className="away">
										{this.props.data.fixture.awayTeam.lightCrest && 
												<img src={placeholder} data-src={this.props.data.fixture.awayTeam.lightCrest.smallUrl} alt={this.props.data.fixture.awayTeam.lightCrest.altText} />
										}
										<p>{this.props.data.fixture.awayTeam.name}</p>
									</div>
								</div>  
							</div>
					}
				</div>  
			</div>
		)
	}
}

module.exports = FixtureHeroModule;



// WEBPACK FOOTER //
// ./src/components/Hero/FixtureHero/FixtureHeroModule.js